import { SetFieldValue } from '../../gs-component-form';

// @ts-ignore
export const resetVendorFields = (setFieldValue: SetFieldValue, index): void => {
  setFieldValue(`events[${index}].location.zip`, '');
  setFieldValue(`events[${index}].location.city`, '');
  setFieldValue(`events[${index}].location.state`, '');
  setFieldValue(`events[${index}].location.country`, '');
  setFieldValue(`events[${index}].location.street1`, '');
  setFieldValue(`events[${index}].location.name`, '');
};

// @ts-ignore
export const resetVendorLocation = (setFieldValue: SetFieldValue, index, initialValues): void => {
  const { name = '', zip = '', city = '', state = '', country = '', street1 = '' } = initialValues.events[
    index
  ].location;
  setFieldValue(`events[${index}].location.name`, name);
  setFieldValue(`events[${index}].location.zip`, zip);
  setFieldValue(`events[${index}].location.city`, city);
  setFieldValue(`events[${index}].location.state`, state);
  setFieldValue(`events[${index}].location.country`, country);
  setFieldValue(`events[${index}].location.street1`, street1);
};

export default resetVendorFields;
